module.exports = __webpack_public_path__ + "WealthCare Saver HSA Consent to Electronic Communications.pdf";